import React from 'react';
import { ProductsShowcaseSection } from '../shared/ProductsShowcaseSection';
import { StarIcon } from 'lucide-react';
import { PRODUCT_IMAGES } from '../../data/productImages';
export function RecommendedProducts() {
  const recommendedProducts = [{
    id: 1,
    name: 'Vitamin D3 5000 IU',
    brand: 'Nature Made',
    price: 14.99,
    originalPrice: 24.99,
    discount: 40,
    rating: 4.8,
    reviewCount: 1456,
    image: PRODUCT_IMAGES[0],
    isBestSeller: true,
    isNew: false,
    expressDelivery: true
  }, {
    id: 2,
    name: 'Omega-3 Fish Oil',
    brand: 'Nordic Naturals',
    price: 22.99,
    originalPrice: 39.99,
    discount: 43,
    rating: 4.9,
    reviewCount: 2103,
    image: PRODUCT_IMAGES[1],
    isBestSeller: true,
    isNew: false,
    expressDelivery: true
  }, {
    id: 3,
    name: 'Multivitamin Complex',
    brand: 'Centrum',
    price: 18.99,
    originalPrice: 29.99,
    discount: 37,
    rating: 4.7,
    reviewCount: 1789,
    image: PRODUCT_IMAGES[2],
    isBestSeller: false,
    isNew: false,
    expressDelivery: true
  }, {
    id: 4,
    name: 'Probiotic 50 Billion CFU',
    brand: 'Garden of Life',
    price: 26.99,
    originalPrice: 44.99,
    discount: 40,
    rating: 4.8,
    reviewCount: 1234,
    image: PRODUCT_IMAGES[3],
    isBestSeller: false,
    isNew: true,
    expressDelivery: true
  }, {
    id: 5,
    name: 'Magnesium Glycinate',
    brand: 'NOW Foods',
    price: 16.99,
    originalPrice: 27.99,
    discount: 39,
    rating: 4.6,
    reviewCount: 987,
    image: PRODUCT_IMAGES[4],
    isBestSeller: false,
    isNew: false,
    expressDelivery: true
  }, {
    id: 6,
    name: 'Vitamin C 1000mg',
    brand: 'Solgar',
    price: 12.99,
    originalPrice: 21.99,
    discount: 41,
    rating: 4.7,
    reviewCount: 1567,
    image: PRODUCT_IMAGES[0],
    isBestSeller: false,
    isNew: false,
    expressDelivery: true
  }];
  return <div className="w-full" data-id="element-2609" data-mp="19v1zzwlclzbe">
      <div className="container mx-auto px-4" data-id="element-2610" data-mp="19wcybgw0yev4">
        <ProductsShowcaseSection title="RECOMMENDED FOR YOU" subtitle="PERSONALIZED PICKS" backgroundColor="bg-gradient-to-r from-blue-600 to-purple-600" products={recommendedProducts} icon={<StarIcon className="w-6 h-6 md:w-8 md:h-8" data-id="element-2612" data-mp="1nm86wdqyiz8b" />} viewAllLink="#recommended" data-id="element-2611" data-mp="1ev7t7h79ntvl" />
      </div>
    </div>;
}